export default __webpack_public_path__ + "static/hittites brochure-9c7ce700a0b42c94cb12ef01c0088840.pdf";